import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { ChevronDown, User, FileText, Sliders, Settings, LogOut, Pencil } from 'lucide-react';
import { API, authHeaders, getToken, clearToken, mediaUrl } from '../lib/auth';

const ITEMS = [
  { to: '/profile', label: 'My Profile', icon: User },
  { to: '/profile?edit=1', label: 'Edit Profile', icon: Pencil },
  { to: '/my-form', label: 'My Form', icon: FileText },
  { to: '/match-preferences', label: 'Match Preferences', icon: Sliders },
  { to: '/settings', label: 'Settings', icon: Settings },
];

export const AccountMenu = () => {
  const navigate = useNavigate();
  const [me, setMe] = useState(null);
  const [open, setOpen] = useState(false);
  const wrap = useRef(null);

  useEffect(() => {
    if (!getToken()) return;
    axios.get(`${API}/user/me`, { headers: authHeaders() })
      .then(({ data }) => setMe(data))
      .catch(() => {});
  }, []);

  useEffect(() => {
    const onDoc = (e) => { if (wrap.current && !wrap.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, []);

  if (!getToken()) return null;

  const first = (me?.name || 'You').split(' ')[0];
  const logout = () => { clearToken(); setOpen(false); navigate('/'); window.location.reload(); };

  return (
    <div className="acct-menu" ref={wrap}>
      <button className="acct-btn" onClick={() => setOpen((o) => !o)} data-testid="account-menu-btn">
        {me?.photo_url ? (
          <img className="acct-av" src={mediaUrl(me.photo_url, true)} alt={first} />
        ) : (
          <span className="acct-av acct-av-txt">{first[0]?.toUpperCase()}</span>
        )}
        <span className="acct-name">My Profile</span>
        <ChevronDown size={14} />
      </button>
      {open && (
        <div className="acct-drop" data-testid="account-menu-dropdown">
          <div className="acct-head">
            <b>{first}</b>
            <span>{me?.krysha_id}</span>
          </div>
          {ITEMS.map(({ to, label, icon: Ic }) => (
            <Link key={to} to={to} onClick={() => setOpen(false)} data-testid={`acct-link-${label.toLowerCase().replace(/ /g, '-')}`}>
              <Ic size={15} /> {label}
            </Link>
          ))}
          <button onClick={logout} data-testid="acct-logout-btn"><LogOut size={15} /> Logout</button>
        </div>
      )}
    </div>
  );
};

export default AccountMenu;
